import { nanoid as nanoidActual } from 'nanoid';

export const nanoid = nanoidActual;
